export default __webpack_public_path__ + "static/media/plumbing.83481cd7.svg";